<template>
 <div id="app">
  <div class="form__field">
   <div class="cell">
    <input @keyup.enter="queryResults" class="ids_topicSearch" id="ctl00_ids_contentPlaceHolder_ids_topicSearch" name="ctl00$ids_contentPlaceHolder$ids_topicSearch" placeholder="Search Contents" type="text" v-model="search"/>
   </div>
   <div class="search_button" v-if="search">
    <button @click="clearResult" class="close-icon">
     &times;
    </button>
   </div>
   <div class="search_button">
    <button @click="queryResults">
     <i class="fa fa-search">
     </i>
    </button>
   </div>
  </div>
  <div class="col-1 l-pad-top" id="results">
   <div>
    <p class="toc-2-style" style="margin-bottom: 10px;">
     <strong v-if="resultsCount != 0">
      ({{resultsCount}}) Results Found
     </strong>
     <strong v-else-if="resultsActual">
      No Results Found
     </strong>
    </p>
   </div>
   <div v-for="result of resultsActual">
    <p class="toc-2-style">
     <a :href="result.link" :keywords="result.keywords" onclick="reload(this.href, this.getAttribute('keywords'))">
      {{result.title}}
     </a>
    </p>
    <p class="toc-3-style">
     {{result.desc}}
    </p>
   </div>
  </div>
  <div class="side-toc" v-if="!resultsActual">
   <p class="toc-1-style">
    <a href="cover.html" title="Markvision Enterprise">
     Markvision Enterprise
    </a>
   </p>
   <p class="toc-1-style">
    <a href="change-history.html#change-history_de" title="&Auml;nderungsverlauf">
     &Auml;nderungsverlauf
    </a>
   </p>
   <div id="divd0e8">
   </div>
   <p class="toc-1-style">
    <a href="overview-chapter.html#overview-chapter_de" title="&Uuml;bersicht">
     &Uuml;bersicht
    </a>
   </p>
   <div id="divd0e252">
    <p class="toc-2-style">
     <a href="overview-chapter.html#overview-markvision-enterprise_de" title="Grundlagen zu Markvision Enterprise">
      Grundlagen zu Markvision Enterprise
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="getting-started-chapter.html#getting-started-chapter_de" title="Erste Schritte">
     Erste Schritte
    </a>
   </p>
   <div id="divd0e281">
    <p class="toc-2-style">
     <a href="best-practices-topic.html#best-practices_de" title="Best Practices">
      Best Practices
     </a>
    </p>
    <p class="toc-2-style">
     <a href="system-requirements-topic.html#system-requirements_de" title="Systemvoraussetzungen">
      Systemvoraussetzungen
     </a>
    </p>
    <p class="toc-2-style">
     <a href="supported-languages-topic.html#supported-languages_de" title="Unterst&uuml;tzte Sprachen">
      Unterst&uuml;tzte Sprachen
     </a>
    </p>
    <p class="toc-2-style">
     <a href="supported-printer-models-topic.html#supported-printer-models_de" title="Unterst&uuml;tzte Druckermodelle">
      Unterst&uuml;tzte Druckermodelle
     </a>
    </p>
    <p class="toc-2-style">
     <a href="setting-up-database-topic.html#setting-up-database_de" title="Einrichten der Datenbank">
      Einrichten der Datenbank
     </a>
    </p>
    <p class="toc-2-style">
     <a href="setting-mve-run-as-user-topic.html#d0e1122" title="Einrichten einer Benutzeranmeldung">
      Einrichten einer Benutzeranmeldung
     </a>
    </p>
    <p class="toc-2-style">
     <a href="installing-markvision-topic.html#installing-markvision_de" title="Installation von MVE">
      Installation von MVE
     </a>
    </p>
    <p class="toc-2-style">
     <a href="installing-mve-silently-topic.html#installing-mve-silently_de" title="Installieren von MVE im Hintergrund">
      Installieren von MVE im Hintergrund
     </a>
    </p>
    <p class="toc-2-style">
     <a href="accessing-mve-topic.html#accessing-mve_de" title="Zugreifen auf MVE">
      Zugreifen auf MVE
     </a>
    </p>
    <p class="toc-2-style">
     <a href="changing-language-topic.html#changing-language_de" title="&Auml;ndern der Sprache">
      &Auml;ndern der Sprache
     </a>
    </p>
    <p class="toc-2-style">
     <a href="changing-your-password-topic.html#changing-your-password_de" title="&Auml;ndern des Passworts">
      &Auml;ndern des Passworts
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="maintaining-application-chapter.html#maintaining-application-chapter_de" title="Warten der Anwendung">
     Warten der Anwendung
    </a>
   </p>
   <div id="divd0e1705">
    <p class="toc-2-style">
     <a href="upgrading-to-latest-version-topic.html#upgrading-to-latest-version_de" title="Aktualisieren auf MVE&nbsp;4.2">
      Aktualisieren auf MVE&nbsp;4.2
     </a>
    </p>
    <p class="toc-2-style">
     <a href="backing-up-and-restoring-database-topic.html#backing-up-and-restoring-database_de" title="Sichern und Wiederherstellen der Datenbank">
      Sichern und Wiederherstellen der Datenbank
     </a>
    </p>
    <p class="toc-2-style">
     <a href="changing-installer-settings-topic.html#changing-installer-settings_de" title="Aktualisieren der Installationsprogramm-Einstellungen nach der Installation">
      Aktualisieren der Installationsprogramm-Einstellungen nach der Installation
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="setting-user-access-chapter.html#setting-user-access-chapter_de" title="Einrichten des Benutzerzugriffs">
     Einrichten des Benutzerzugriffs
    </a>
   </p>
   <div id="divd0e1977">
    <p class="toc-2-style">
     <a href="setting-up-user-access-overview-topic.html#setting-up-user-access-overview_de" title="&Uuml;bersicht">
      &Uuml;bersicht
     </a>
    </p>
    <p class="toc-2-style">
     <a href="understanding-user-roles-topic.html#understanding-user-roles_de" title="Informationen zu Benutzerrollen">
      Informationen zu Benutzerrollen
     </a>
    </p>
    <p class="toc-2-style">
     <a href="managing-users-topic.html#managing-users_de" title="Verwalten von Benutzern">
      Verwalten von Benutzern
     </a>
    </p>
    <p class="toc-2-style">
     <a href="enabling-ldap-server-authentication-topic.html#enabling-ldap-server-authentication_de" title="Aktivieren der LDAP-Server-Authentifizierung">
      Aktivieren der LDAP-Server-Authentifizierung
     </a>
    </p>
    <p class="toc-2-style">
     <a href="installing-ldap-server-certificates-topic.html#installing-ldap-server-certificates_de" title="Installieren von LDAP-Serverzertifikaten">
      Installieren von LDAP-Serverzertifikaten
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="discovering-devices-chapter.html#discovering-devices-chapter_de" title="Erkennen von Druckern">
     Erkennen von Druckern
    </a>
   </p>
   <div id="divd0e2358">
    <p class="toc-2-style">
     <a href="creating-discovery-profile-topic.html#creating-discovery-profile_de" title="Erstellen eines Suchprofils">
      Erstellen eines Suchprofils
     </a>
    </p>
    <p class="toc-2-style">
     <a href="managing-discovery-profiles-topic.html#managing-discovery-profiles_de" title="Verwalten von Suchprofilen">
      Verwalten von Suchprofilen
     </a>
    </p>
    <p class="toc-2-style">
     <a href="sample-scenario-discovering-printers-topic.html#sample-scenario-discovering-printers_de" title="Beispielszenario: Erkennen von Druckern">
      Beispielszenario: Erkennen von Druckern
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="maintaining-dashboard-chapter.html#maintaining-dashboard-chapter_de" title="Verwalten des Sicherheits-Dashboards">
     Verwalten des Sicherheits-Dashboards
    </a>
   </p>
   <div id="divd0e2614">
    <p class="toc-2-style">
     <a href="overview-security-dashboard-topic.html#overview-security-dashboard_de" title="&Uuml;bersicht">
      &Uuml;bersicht
     </a>
    </p>
    <p class="toc-2-style">
     <a href="accessing-dashboard-topic.html#accessing-dashboard_de" title="Zugriff auf das Sicherheits-Dashboard">
      Zugriff auf das Sicherheits-Dashboard
     </a>
    </p>
    <p class="toc-2-style">
     <a href="managing-device-security-information-topic.html#managing-device-security-information_de" title="Verwalten der Ger&auml;te-Sicherheitsinformationen">
      Verwalten der Ger&auml;te-Sicherheitsinformationen
     </a>
    </p>
    <p class="toc-2-style">
     <a href="managing-device-conformance-check-topic.html#managing-device-conformance-check_de" title="Verwalten der Ger&auml;tekonformit&auml;tspr&uuml;fung">
      Verwalten der Ger&auml;tekonformit&auml;tspr&uuml;fung
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="finding-devices-chapter.html#finding-devices-chapter_de" title="Anzeigen von Druckern">
     Anzeigen von Druckern
    </a>
   </p>
   <div id="divd0e2702">
    <p class="toc-2-style">
     <a href="viewing-printer-list-topic.html#viewing-printer-list_de" title="Anzeigen der Druckerliste">
      Anzeigen der Druckerliste
     </a>
    </p>
    <p class="toc-2-style">
     <a href="viewing-device-information-topic.html#viewing-device-information_de" title="Anzeigen der Druckerinformationen">
      Anzeigen der Druckerinformationen
     </a>
    </p>
    <p class="toc-2-style">
     <a href="exporting-data-topic.html#exporting-data_de" title="Exportieren von Druckerdaten">
      Exportieren von Druckerdaten
     </a>
    </p>
    <p class="toc-2-style">
     <a href="managing-views-topic.html#managing-views_de" title="Verwalten von Ansichten">
      Verwalten von Ansichten
     </a>
    </p>
    <p class="toc-2-style">
     <a href="changing-printer-listing-view-topic.html#changing-printer-listing-view_de" title="Druckerlistenansicht &auml;ndern">
      Druckerlistenansicht &auml;ndern
     </a>
    </p>
    <p class="toc-2-style">
     <a href="filtering-printers-using-search-bar-topic.html#filtering-printers-using-search-bar_de" title="Filtern von Druckern &uuml;ber die Suchleiste">
      Filtern von Druckern &uuml;ber die Suchleiste
     </a>
    </p>
    <p class="toc-2-style">
     <a href="managing-keywords-topic.html#managing-keywords_de" title="Verwalten von Schl&uuml;sselw&ouml;rtern">
      Verwalten von Schl&uuml;sselw&ouml;rtern
     </a>
    </p>
    <p class="toc-2-style">
     <a href="understanding-device-life-cycle-states-topic.html#d0e3162" title="Verwenden gespeicherter Suchvorg&auml;nge">
      Verwenden gespeicherter Suchvorg&auml;nge
     </a>
    </p>
    <p class="toc-2-style">
     <a href="sample-scenario-monitor-fleet-topic.html#sample-scenario-monitor-fleet_de" title="Beispielszenario: &Uuml;berwachung der Tonerst&auml;nde Ihrer Flotte">
      Beispielszenario: &Uuml;berwachung der Tonerst&auml;nde Ihrer Flotte
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="securing-devices-chapter.html#securing-devices-chapter_de" title="Sichern der Druckerkommunikation">
     Sichern der Druckerkommunikation
    </a>
   </p>
   <div id="divd0e4099">
    <p class="toc-2-style">
     <a href="understanding-security-status-topic.html#understanding-security-status_de" title="Bedeutung des Druckersicherheitsstatus">
      Bedeutung des Druckersicherheitsstatus
     </a>
    </p>
    <p class="toc-2-style">
     <a href="securing-printers-using-default-config-topic.html#securing-printers-using-default-config_de" title="Sichern von Druckern unter Verwendung der Standardkonfigurationen">
      Sichern von Druckern unter Verwendung der Standardkonfigurationen
     </a>
    </p>
    <p class="toc-2-style">
     <a href="understanding-fac-permissions-topic.html#understanding-fac-permissions_de" title="Bedeutung von Berechtigungen und Funktionszugriffssteuerungen">
      Bedeutung von Berechtigungen und Funktionszugriffssteuerungen
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configuring-device-security-topic.html#configuring-device-security_de" title="Konfigurieren der Druckersicherheit">
      Konfigurieren der Druckersicherheit
     </a>
    </p>
    <p class="toc-2-style">
     <a href="securing-printer-communications-on-your-fleet-topic.html#securing-printer-communications-on-your-fleet_de" title="Sichern der Kommunikation in der Druckerflotte">
      Sichern der Kommunikation in der Druckerflotte
     </a>
    </p>
    <p class="toc-2-style">
     <a href="securing-printers-topic.html#securing-printers_de" title="Andere M&ouml;glichkeiten, Ihre Drucker zu sch&uuml;tzen">
      Andere M&ouml;glichkeiten, Ihre Drucker zu sch&uuml;tzen
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="managing-assets-chapter.html#managing-assets-chapter_de" title="Verwalten von Druckern">
     Verwalten von Druckern
    </a>
   </p>
   <div id="divd0e4463">
    <p class="toc-2-style">
     <a href="restarting-printer-topic.html#restarting-printer_de" title="Neustarten des Druckers">
      Neustarten des Druckers
     </a>
    </p>
    <p class="toc-2-style">
     <a href="viewing-ews-topic.html#viewing-ews_de" title="Anzeigen des Embedded Web Servers des Druckers">
      Anzeigen des Embedded Web Servers des Druckers
     </a>
    </p>
    <p class="toc-2-style">
     <a href="auditing-devices-topic.html#auditing-devices_de" title="&Uuml;berpr&uuml;fen von Druckern">
      &Uuml;berpr&uuml;fen von Druckern
     </a>
    </p>
    <p class="toc-2-style">
     <a href="updating-printer-status-topic.html#updating-printer-status_de" title="Aktualisieren des Druckerstatus">
      Aktualisieren des Druckerstatus
     </a>
    </p>
    <p class="toc-2-style">
     <a href="setting-device-state-topic.html#setting-device-state_de" title="Einstellen des Druckerstatus">
      Einstellen des Druckerstatus
     </a>
    </p>
    <p class="toc-2-style">
     <a href="assigning-configurations-to-devices-topic.html#assigning-configurations-to-devices_de" title="Zuweisen von Konfigurationen zu Druckern">
      Zuweisen von Konfigurationen zu Druckern
     </a>
    </p>
    <p class="toc-2-style">
     <a href="unassigning-configurations-topic.html#unassigning-configurations_de" title="Aufheben der Zuweisung von Konfigurationen">
      Aufheben der Zuweisung von Konfigurationen
     </a>
    </p>
    <p class="toc-2-style">
     <a href="enforcing-configurations-topic.html#enforcing-configurations_de" title="Durchsetzen von Konfigurationen">
      Durchsetzen von Konfigurationen
     </a>
    </p>
    <p class="toc-2-style">
     <a href="checking-device-conformance-topic.html#checking-device-conformance_de" title="Pr&uuml;fen der Drucker&uuml;bereinstimmung mit einer Konfiguration">
      Pr&uuml;fen der Drucker&uuml;bereinstimmung mit einer Konfiguration
     </a>
    </p>
    <p class="toc-2-style">
     <a href="deploying-files-to-printers-topic.html#deploying-files-to-printers_de" title="Bereitstellen von Dateien f&uuml;r Drucker">
      Bereitstellen von Dateien f&uuml;r Drucker
     </a>
    </p>
    <p class="toc-2-style">
     <a href="updating-printer-firmware-topic.html#updating-printer-firmware_de" title="Aktualisieren der Drucker-Firmware">
      Aktualisieren der Drucker-Firmware
     </a>
    </p>
    <p class="toc-2-style">
     <a href="uninstalling-applications-from-devices-topic.html#uninstalling-applications-from-devices_de" title="Deinstallieren von Anwendungen auf Druckern">
      Deinstallieren von Anwendungen auf Druckern
     </a>
    </p>
    <p class="toc-2-style">
     <a href="assigning-events-to-device-topic.html#assigning-events-to-device_de" title="Zuweisen von Ereignissen zu Druckern">
      Zuweisen von Ereignissen zu Druckern
     </a>
    </p>
    <p class="toc-2-style">
     <a href="assigning-keyword-topic.html#assigning-keyword_de" title="Zuweisen von Stichw&ouml;rtern zu Druckern">
      Zuweisen von Stichw&ouml;rtern zu Druckern
     </a>
    </p>
    <p class="toc-2-style">
     <a href="entering-credentials-secured-printers-topic.html#entering-credentials-secured-printers_de" title="Eingeben von Anmeldeinformationen f&uuml;r gesicherte Drucker">
      Eingeben von Anmeldeinformationen f&uuml;r gesicherte Drucker
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configuring-printer-certificates-manually-topic.html#configuring-printer-certificates-manually_de" title="Manuelles Konfigurieren von Standarddruckerzertifikaten">
      Manuelles Konfigurieren von Standarddruckerzertifikaten
     </a>
    </p>
    <p class="toc-2-style">
     <a href="removing-printers-topic.html#removing-printers_de" title="Entfernen von Druckern">
      Entfernen von Druckern
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="managing-configurations-chapter.html#managing-configurations-chapter_de" title="Verwalten von Konfigurationen">
     Verwalten von Konfigurationen
    </a>
   </p>
   <div id="divd0e5069">
    <p class="toc-2-style">
     <a href="managing-configurations-overview-topic.html#managing-configurations-overview_de" title="&Uuml;bersicht">
      &Uuml;bersicht
     </a>
    </p>
    <p class="toc-2-style">
     <a href="creating-configuration-topic.html#creating-configuration_de" title="Erstellen einer Konfiguration">
      Erstellen einer Konfiguration
     </a>
    </p>
    <p class="toc-2-style">
     <a href="creating-configuration-from-printer-topic.html#creating-configuration-from-printer_de" title="Erstellen einer Konfiguration &uuml;ber einen Drucker">
      Erstellen einer Konfiguration &uuml;ber einen Drucker
     </a>
    </p>
    <p class="toc-2-style">
     <a href="sample-scenario-cloning-configurations-topic.html#sample-scenario-cloning-configurations_de" title="Beispielszenario: Duplizieren einer Konfiguration">
      Beispielszenario: Duplizieren einer Konfiguration
     </a>
    </p>
    <p class="toc-2-style">
     <a href="creating-advanced-security-component-topic.html#creating-advanced-security-component_de" title="Erstellen einer erweiterten Sicherheitskomponente von einem Drucker">
      Erstellen einer erweiterten Sicherheitskomponente von einem Drucker
     </a>
    </p>
    <p class="toc-2-style">
     <a href="generating-printable-version-topic.html#generating-printable-version_de" title="Erstellen einer druckbaren Version der Konfigurationseinstellungen">
      Erstellen einer druckbaren Version der Konfigurationseinstellungen
     </a>
    </p>
    <p class="toc-2-style">
     <a href="understanding-dynamic-settings-topic.html#understanding-dynamic-settings_de" title="Grundlagen zu dynamischen Einstellungen">
      Grundlagen zu dynamischen Einstellungen
     </a>
    </p>
    <p class="toc-2-style">
     <a href="understanding-variable-settings-topic.html#understanding-variable-settings_de" title="Grundlagen zu Variableneinstellungen">
      Grundlagen zu Variableneinstellungen
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configuring-color-permissions-topic.html#configuring-color-permissions_de" title="Farbdruckberechtigungen konfigurieren">
      Farbdruckberechtigungen konfigurieren
     </a>
    </p>
    <p class="toc-2-style">
     <a href="creating-applications-package-topic.html#creating-applications-package_de" title="Erstellen eines Anwendungspakets">
      Erstellen eines Anwendungspakets
     </a>
    </p>
    <p class="toc-2-style">
     <a href="importing-exporting-configuration-file-topic.html#importing-exporting-configuration-file_de" title="Importieren oder Exportieren einer Konfiguration">
      Importieren oder Exportieren einer Konfiguration
     </a>
    </p>
    <p class="toc-2-style">
     <a href="importing-files-to-resource-library-topic.html#importing-files-to-resource-library_de" title="Importieren von Dateien in die Ressourcenbibliothek">
      Importieren von Dateien in die Ressourcenbibliothek
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="setting-up-cert-auto-manage-chapter.html#setting-up-cert-auto-manage-chapter_de" title="Verwalten von Zertifikaten">
     Verwalten von Zertifikaten
    </a>
   </p>
   <div id="divd0e5593">
    <p class="toc-2-style">
     <a href="setting-up-MVE-manage-certificates-automatically-group.html#d0e5596" title="Einrichten von MVE zur automatischen Verwaltung von Zertifikaten">
      Einrichten von MVE zur automatischen Verwaltung von Zertifikaten
     </a>
    </p>
    <p class="toc-2-style">
     <a href="managing-certificates-using-SCEP-group.html#d0e5922" title="Verwalten von Zertifikaten mit Microsoft Certificate Authority &uuml;ber SCEP">
      Verwalten von Zertifikaten mit Microsoft Certificate Authority &uuml;ber SCEP
     </a>
    </p>
    <p class="toc-2-style">
     <a href="managing-certificates-using-MSCEWS-group.html#d0e6644" title="Verwalten von Zertifikaten mit Microsoft Certificate Authority &uuml;ber MSCEWS">
      Verwalten von Zertifikaten mit Microsoft Certificate Authority &uuml;ber MSCEWS
     </a>
    </p>
    <p class="toc-2-style">
     <a href="managing-certificates-using-OpenXPKI-CA-group.html#d0e7629" title="Verwalten von Zertifikaten mit OpenXPKI Certificate Authority &uuml;ber SCEP">
      Verwalten von Zertifikaten mit OpenXPKI Certificate Authority &uuml;ber SCEP
     </a>
    </p>
    <p class="toc-2-style">
     <a href="managing-certificates-using-EST-group.html#d0e8696" title="Verwalten von Zertifikaten mit OpenXPKI Certificate Authority &uuml;ber EST">
      Verwalten von Zertifikaten mit OpenXPKI Certificate Authority &uuml;ber EST
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="managing-device-alerts-chapter.html#managing-device-alerts-chapter_de" title="Verwalten von Druckerwarnungen">
     Verwalten von Druckerwarnungen
    </a>
   </p>
   <div id="divd0e9781">
    <p class="toc-2-style">
     <a href="managing-printer-alerts-overview-topic.html#managing-printer-alerts-overview_de" title="&Uuml;bersicht">
      &Uuml;bersicht
     </a>
    </p>
    <p class="toc-2-style">
     <a href="creating-action-topic.html#creating-action_de" title="Erstellen einer Aktion">
      Erstellen einer Aktion
     </a>
    </p>
    <p class="toc-2-style">
     <a href="understanding-action-placeholders-topic.html#understanding-action-placeholders_de" title="Informationen zu Aktionsplatzhaltern">
      Informationen zu Aktionsplatzhaltern
     </a>
    </p>
    <p class="toc-2-style">
     <a href="managing-actions-topic.html#managing-actions_de" title="Verwalten von Aktionen">
      Verwalten von Aktionen
     </a>
    </p>
    <p class="toc-2-style">
     <a href="creating-event-topic.html#creating-event_de" title="Erstellen von Ereignissen">
      Erstellen von Ereignissen
     </a>
    </p>
    <p class="toc-2-style">
     <a href="understanding-printer-alerts-topic.html#understanding-printer-alerts_de" title="Informationen zu Druckerwarnungen">
      Informationen zu Druckerwarnungen
     </a>
    </p>
    <p class="toc-2-style">
     <a href="managing-events-topic.html#managing-events_de" title="Verwalten von Ereignissen">
      Verwalten von Ereignissen
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="viewing-tasks-chapter.html#viewing-tasks-chapter_de" title="Anzeigen von Aufgabestatus und Verlauf">
     Anzeigen von Aufgabestatus und Verlauf
    </a>
   </p>
   <div id="divd0e10413">
    <p class="toc-2-style">
     <a href="viewing-task-status-history-overview-topic.html#viewing-task-status-history-overview_de" title="&Uuml;bersicht">
      &Uuml;bersicht
     </a>
    </p>
    <p class="toc-2-style">
     <a href="viewing-task-status-topic.html#viewing-task-status_de" title="Anzeigen des Aufgabenstatus">
      Anzeigen des Aufgabenstatus
     </a>
    </p>
    <p class="toc-2-style">
     <a href="stopping-tasks-topic.html#stopping-tasks_de" title="Aufgaben werden angehalten">
      Aufgaben werden angehalten
     </a>
    </p>
    <p class="toc-2-style">
     <a href="viewing-logs-topic.html#viewing-logs_de" title="Anzeigen von Protokollen">
      Anzeigen von Protokollen
     </a>
    </p>
    <p class="toc-2-style">
     <a href="clearing-logs-topic.html#clearing-logs_de" title="Protokolle l&ouml;schen">
      Protokolle l&ouml;schen
     </a>
    </p>
    <p class="toc-2-style">
     <a href="exporting-logs-topic.html#exporting-logs_de" title="Exportieren von Protokollen">
      Exportieren von Protokollen
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="scheduling-tasks.html#scheduling-tasks_de" title="Festlegen von Zeitpl&auml;nen f&uuml;r Aufgaben">
     Festlegen von Zeitpl&auml;nen f&uuml;r Aufgaben
    </a>
   </p>
   <div id="divd0e10521">
    <p class="toc-2-style">
     <a href="creating-schedule-topic.html#creating-schedule_de" title="Erstellen eines Zeitplans">
      Erstellen eines Zeitplans
     </a>
    </p>
    <p class="toc-2-style">
     <a href="managing-schedules-topic.html#managing-schedules_de" title="Verwalten von geplanten Aufgaben">
      Verwalten von geplanten Aufgaben
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="admin-tasks-chapter.html#admin-tasks-chapter_de" title="Ausf&uuml;hren weiterer Verwaltungsaufgaben">
     Ausf&uuml;hren weiterer Verwaltungsaufgaben
    </a>
   </p>
   <div id="divd0e10663">
    <p class="toc-2-style">
     <a href="configuring-system-settings-topic.html#configuring-system-settings_de" title="Konfigurieren allgemeiner Einstellungen">
      Konfigurieren allgemeiner Einstellungen
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configuring-email-settings-topic.html#configuring-email-settings_de" title="Konfigurieren der E-Mail-Einstellungen">
      Konfigurieren der E-Mail-Einstellungen
     </a>
    </p>
    <p class="toc-2-style">
     <a href="adding-login-disclaimer-topic.html#adding-login-disclaimer_de" title="Hinzuf&uuml;gen eines Haftungsausschlusses bei Anmeldung">
      Hinzuf&uuml;gen eines Haftungsausschlusses bei Anmeldung
     </a>
    </p>
    <p class="toc-2-style">
     <a href="signing-mve-certificate-topic.html#signing-mve-certificate_de" title="Signieren des MVE-Zertifikats">
      Signieren des MVE-Zertifikats
     </a>
    </p>
    <p class="toc-2-style">
     <a href="removing-user-information-topic.html#removing-user-information_de" title="Entfernen von Benutzerinformationen und Verweisen">
      Entfernen von Benutzerinformationen und Verweisen
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="faq-chapter.html#faq-chapter_de" title="H&auml;ufig gestellte Fragen">
     H&auml;ufig gestellte Fragen
    </a>
   </p>
   <div id="divd0e10908">
    <p class="toc-2-style">
     <a href="faq-chapter.html#frequently-asked-questions_de" title="Markvision Enterprise&nbsp;&ndash; FAQ">
      Markvision Enterprise&nbsp;&ndash; FAQ
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="troubleshooting-chapter.html#troubleshooting-chapter_de" title="Fehlerbehebung">
     Fehlerbehebung
    </a>
   </p>
   <div id="divd0e11102">
    <p class="toc-2-style">
     <a href="trb-forgotten-password-mve-topic.html#trb-forgotten-password-mve_de" title="Benutzer hat das Passwort vergessen">
      Benutzer hat das Passwort vergessen
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-admin-forgotten-password-mve-topic.html#trb-admin-forgotten-password-mve_de" title="Administrator hat das Kennwort vergessen.">
      Administrator hat das Kennwort vergessen.
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-page-loading-infinitely-topic.html#trb-page-loading-infinitely_de" title="Seite wird nicht geladen">
      Seite wird nicht geladen
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-cannot-discover-network-device-topic.html#trb-cannot-discover-network-device_de" title="Netzwerkdrucker kann nicht gefunden werden">
      Netzwerkdrucker kann nicht gefunden werden
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-incorrect-device-information-topic.html#trb-incorrect-device-information_de" title="Falsche Druckerinformationen">
      Falsche Druckerinformationen
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-mve-does-not-recognize-secured-printer-topic.html#trb-mve-does-not-recognize-secured-printer_de" title="MVE erkennt einen Drucker nicht als gesicherten Drucker.">
      MVE erkennt einen Drucker nicht als gesicherten Drucker.
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-config-enforcement-fails-topic.html#trb-config-enforcement-fails_de" title="Das Erzwingen von Konfigurationen mit mehreren Anwendungen schl&auml;gt beim ersten Versuch fehl, ist jedoch bei den nachfolgenden Versuchen erfolgreich.">
      Das Erzwingen von Konfigurationen mit mehreren Anwendungen schl&auml;gt beim ersten Versuch fehl, ist jedoch bei den nachfolgenden Versuchen erfolgreich.
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-enforcement-printer-cert-fails-topic.html#trb-enforcement-printer-cert-fails_de" title="Die Durchsetzung von Konfigurationen mit Druckerzertifikat schl&auml;gt fehl">
      Die Durchsetzung von Konfigurationen mit Druckerzertifikat schl&auml;gt fehl
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-openxpki-ca-group.html#d0e11321" title="OpenXPKI Zertifizierungsstelle">
      OpenXPKI Zertifizierungsstelle
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="appendix-chapter.html#appendix-chapter_de" title="Anhang">
     Anhang
    </a>
   </p>
   <div id="divd0e11491">
    <p class="toc-2-style">
     <a href="understanding-ports-and-protocols-topic.html#understanding-ports-and-protocols_de" title="Erl&auml;uterungen zu Anschl&uuml;ssen und Protokollen">
      Erl&auml;uterungen zu Anschl&uuml;ssen und Protokollen
     </a>
    </p>
    <p class="toc-2-style">
     <a href="enabling-automatic-approval-certificate-requests-microsoft-ca-topic.html#enabling-automatic-approval-certificate-requests-microsoft-ca_de" title="Aktivieren der automatischen Genehmigung von Zertifikatsanforderungen in Microsoft CA">
      Aktivieren der automatischen Genehmigung von Zertifikatsanforderungen in Microsoft CA
     </a>
    </p>
    <p class="toc-2-style">
     <a href="revoking-certificates-topic.html#revoking-certificates_de" title="Widerrufen von Zertifikaten">
      Widerrufen von Zertifikaten
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="leap_notices.html#leap_notices_de" title="Hinweise">
     Hinweise
    </a>
   </p>
   <div id="divd0e11867">
    <p class="toc-2-style">
     <a href="leap_notices.html#d0e11870" title="Hinweis zur Ausgabe">
      Hinweis zur Ausgabe
     </a>
    </p>
    <p class="toc-2-style">
     <a href="leap_notices.html#d0e11906" title="Marken">
      Marken
     </a>
    </p>
    <p class="toc-2-style">
     <a href="leap_notices.html#us-government-rights_de" title="GOVERNMENT END USERS">
      GOVERNMENT END USERS
     </a>
    </p>
    <p class="toc-2-style">
     <a href="leap_notices.html#jmdns-license_de" title="JmDNS License">
      JmDNS License
     </a>
    </p>
    <p class="toc-2-style">
     <a href="leap_notices.html#licensing-notices-program-folder_de" title="Lizenzhinweise">
      Lizenzhinweise
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="glossary.html#glossary_de" title="Glossar">
     Glossar
    </a>
   </p>
   <div id="divd0e11936">
   </div>
  </div>
 </div>
</template>
<script>
 import output from './output.json';

const fuzzysort = require('fuzzysort');
const lunr = require("lunr")
require("lunr-languages/lunr.stemmer.support.js")(lunr)
require('lunr-languages/lunr.multi')(lunr)
require("lunr-languages/tinyseg.js")(lunr)
require("lunr-languages/lunr.de.js")(lunr)
require("lunr-languages/lunr.es.js")(lunr)
require("lunr-languages/lunr.fr.js")(lunr)
require("lunr-languages/lunr.it.js")(lunr)
require("lunr-languages/lunr.ja.js")(lunr)
require("lunr-languages/lunr.pt.js")(lunr)

export default {
  name: 'app',
  data() {
    return {
        search: '',
        resultsActual: '',
        list: output,
        resultsCount: 0,
    }
  },

  methods: { queryResults() {

      if (this.search.trim() === ''){
        return  '';
      }
    //   else if(this.search.trim().length < 3){
    //     this.resultsActual = new Array();
    //     this.resultsCount = 0;
    //   }
      else {
        var documents = this.list;

        var idx = lunr(function () {
            this.use(lunr.ja);
            this.use(lunr.multiLanguage('en', 'de', 'es', 'fr', 'it', 'ja', 'pt'))
            this.ref('UUID');
            this.field('title');
            this.field('descFull');
            this.metadataWhitelist = ['position'];

            documents.forEach(function (doc) {
                        this.add(doc)
                    },this);
            });
        

        var searchTerms = this.search.replace(/[`~!#$%^&*()|+\-=?;:'",.<>\{\}\[\]\\/]/gi, ' ').trim().replace(/\s\s+/g, " ");
        // var searchTerms = this.search;
        searchTerms = this.removeStopWords(searchTerms);
        var searchRawTerms = searchTerms;
        // searchTerms  =  searchTerms.split(" ").join(" +");
        // searchTerms = searchTerms.startsWith(" +") ? searchTerms : "+" + searchTerms;

        console.log(searchTerms);
        var results = idx.search(searchTerms);

        console.log (results);

        results = results.map(res => {
            var linkRes =  documents.find(elem => elem.UUID == res.ref);
            var keywords_array = new Array();
            var keywords_arrays = new Array();
            var keywords_arrays_title = new Array();

            Object.keys(res.matchData.metadata).map(kys => {
                var positions_title = res.matchData.metadata[kys].title;
                var positions_desc = res.matchData.metadata[kys].descFull;

                if(typeof positions_title !== 'undefined' ){
                    positions_title.position.forEach(function(val, i, arr){
                        keywords_array.push(linkRes.descFull.substring(val[0],val[0] + val[1]));
                        keywords_arrays_title.push(val[0],val[1]);
                    });
                }

                if(typeof positions_desc !== 'undefined' ){
                    positions_desc.position.forEach(function(val, i, arr){
                        keywords_array.push(linkRes.descFull.substring(val[0],val[0] + val[1]));
                        keywords_arrays.push(val[0],val[1]);
                    });
                }
            });

            

            res.link = linkRes.link;
            res.desc = linkRes.desc;
            res.title = linkRes.title;
            res.full = linkRes.descFull;
            res.titleArray = keywords_arrays_title;
            res.descArray = keywords_arrays;
            keywords_array = keywords_array.filter(function(item, index){ 
                return searchRawTerms.indexOf(item) >= 0;
            });
            var keywords_set = new Set(keywords_array);
            res.keywords = [...keywords_set].toString();
            // res.keywords = ["ramon","joe","gudz"]
            return res;
        });
        
        var existingPagesInResult = new Array();
        

       
        results = results.filter(function(item, index){
                
            if(existingPagesInResult.includes(item.link)){
                
                return false;
            }
            else { 
                existingPagesInResult.push(item.link);
                return true;
            }

            if(res.keywords == ""){
                return false;
            }
        });

        

        console.log (results);
        this.resultsActual = results;
        this.resultsCount = results.length;
      }
    },

    clearResult: function(){
        this.search = "";
        this.resultsActual = undefined;
        this.resultsCount = 0;
        reload("cover.html", "");
       
    },  

    removeStopWords: function(queryString) {
        const stopWords = ['i', 'me', 'my', 'myself', 'we', 'our', 'ours', 'ourselves', 'you', "you're", "you've", "you'll", "you'd", 'your', 'yours', 'yourself', 'yourselves', 
        'he', 'him', 'his', 'himself', 'she', "she's", 'her', 'hers', 'herself', 'it', "it's", 'its', 'itself', 'they', 'them', 'their', 'theirs', 'themselves', 'what', 'which', 
        'who', 'whom', 'this', 'that', "that'll", 'these', 'those', 'am', 'is', 'are', 'was', 'were', 'be', 'been', 'being', 'have', 'has', 'had', 'having', 'do', 'does', 'did', 
        'doing', 'a', 'an', 'the', 'and', 'but', 'if', 'or', 'because', 'as', 'until', 'while', 'of', 'at', 'by', 'for', 'with', 'about', 'against', 'between', 'into', 'through', 
        'during', 'before', 'after', 'above', 'below', 'to', 'from', 'up', 'down', 'in', 'out', 'on', 'off', 'over', 'under', 'again', 'further', 'then', 'once', 'here', 'there', 
        'when', 'where', 'why', 'how', 'all', 'any', 'both', 'each', 'few', 'more', 'most', 'other', 'some', 'such', 'no', 'nor', 'not', 'only', 'own', 'same', 'so', 'than', 'too', 
        'very', 's', 't', 'can', 'will', 'just', 'don', "don't", 'should', "should've", 'now', 'd', 'll', 'm', 'o', 're', 've', 'y', 'ain', 'aren', "aren't", 'couldn', "couldn't", 
        'didn', "didn't", 'doesn', "doesn't", 'hadn', "hadn't", 'hasn', "hasn't", 'haven', "haven't", 'isn', "isn't", 'ma', 'mightn', "mightn't", 'mustn', "mustn't", 'needn', 
         "needn't", 'shan', "shan't", 'shouldn', "shouldn't", 'wasn', "wasn't", 'weren', "weren't", 'won', "won't", 'wouldn', "wouldn't"]

        var cleanQueryString = new Array();
        queryString.split(" ").forEach(word => {
             if(!stopWords.includes(word)) {
                 cleanQueryString.push(word);
             }
        });

        return cleanQueryString.join(" ");
    },
    
  }
}
</script>


// WEBPACK FOOTER //
// src/App.vue